// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"55f54e89","455":"909aed07","488":"66c316c5","717":"ce08f6a9","757":"7805b2b3","811":"f8e29cff","819":"ba1406ec","836":"c8ebd50b","849":"5835b347","977":"f5039bc1"}[chunkId] + ".chunk.js";
};